// extracted by mini-css-extract-plugin
export var body = "_mg-8";
export var button = "_mg-0";
export var closeButton = "_mg-5";
export var content = "_mg-3";
export var empty = "_mg-f";
export var grid = "_mg-c";
export var header = "_mg-4";
export var icon = "_mg-1";
export var option = "_mg-d";
export var optionSelected = "_mg-e";
export var overlay = "_mg-2";
export var searchIcon = "_mg-a";
export var searchInput = "_mg-b";
export var searchWrapper = "_mg-9";
export var title = "_mg-6";
export var visuallyHidden = "_mg-7";